import { useState, useEffect, useCallback } from 'react';
import { apiService } from '../services/api';
import { Fornecedor, FornecedorFilters } from '../types/fornecedor';

export const useFornecedores = (initialFilters?: FornecedorFilters) => {
  const [fornecedores, setFornecedores] = useState<Fornecedor[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [filters, setFilters] = useState<FornecedorFilters | undefined>(initialFilters);

  const fetchFornecedores = useCallback(async (filterParams?: FornecedorFilters) => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiService.getFornecedores(filterParams || filters);
      
      if (response.success) {
        setFornecedores(response.data || []);
      } else {
        setError(response.message || 'Erro ao buscar fornecedores');
        setFornecedores([]);
      }
    } catch (error) {
      console.error('Erro ao buscar fornecedores:', error);
      setError(error instanceof Error ? error.message : 'Erro ao buscar fornecedores');
      setFornecedores([]);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  // Fetch inicial
  useEffect(() => {
    fetchFornecedores();
  }, [fetchFornecedores]);

  // Método para atualizar filtros e refazer a busca
  const updateFilters = useCallback((newFilters: FornecedorFilters) => {
    setFilters(newFilters);
    fetchFornecedores(newFilters);
  }, [fetchFornecedores]);

  // Método para refazer a busca com os mesmos filtros
  const refetchFornecedores = useCallback(() => {
    fetchFornecedores();
  }, [fetchFornecedores]);

  return {
    fornecedores,
    loading,
    error,
    filters,
    updateFilters,
    refetchFornecedores
  };
};